// Copyright (c) 2024. UpCircle Technology AG.
// All rights reserved. Redistribution in source and/or binary forms,
// with or without modification, is not permitted.

// This file includes firebase resources and API,
// exported to enable authentication and use across all other scripts.

/* eslint-env node */
/* global process */
// firebase resources
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
  connectFirestoreEmulator,
} from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getAnalytics } from 'firebase/analytics';

// Firebase webapp configuration (app nickname: Analytics Dashboard)
// REAL DATABASE BELOW
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// initialize firebase and resources
const firebaseApp = initializeApp(firebaseConfig);
const auth = getAuth(firebaseApp);
const storage = getStorage(firebaseApp);
const firestore = initializeFirestore(firebaseApp, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
});
const functions = getFunctions(firebaseApp);
const analytics = getAnalytics(firebaseApp);

// connect to firebase emulator if in development mode
const USE_EMULATOR = false;
const EMULATOR_IP = '192.168.178.24';
if (USE_EMULATOR) {
  connectFirestoreEmulator(firestore, EMULATOR_IP, 8080);
  connectFunctionsEmulator(functions, EMULATOR_IP, 5001);
}

export { firebaseApp, auth, storage, firestore, functions, analytics };
